<template>
    <div class="viewLEICO">
        <div class="modal-conteudo">
            <div id="divImprimir" v-if="dados.legislacao">
                <h3>{{ dados.legislacao.nmTitulo }}</h3>
                <p class="subtituloLei"
                   v-if="dados.legislacao.dsLegislacao"
                   v-html="dados.legislacao.dsLegislacao.replace('\r\n','<br />')"></p>
                <div class="aparato-resumo" v-if="dados.flExibeLeiComentada && totalAnotacoes">
                    <span class="selo" v-if="totalNotas"><i class="i-nota"></i> {{ totalNotas }} anotações</span>
                    <span class="selo" v-if="totalReg"><i class="i-reg"></i> {{ totalReg }} regulamentações</span>
                </div>
                <div id="htmlLegislacao" @click="handleClick"></div>
            </div>
        </div>
        <div class="d-none" id="conteudoImprimir"></div>

        <div class="modal-footer">
            <p class="origem" v-if="dados.legislacao">{{ dados.legislacao.nmTitulo }}</p>
            <div class="acoes">
                <button class="btn-imprimir" type="button" @click="imprimir">
                    <i class="fas fa-print"></i> Imprimir
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import { urlApi } from '@/config/global'
    import axios from 'axios'
    import { htmlGatilhoAnotacao, htmlPainelAnotacao, cssImpressaoLei } from './leiAnotacao'
    import { normalizarLinksConteudoNoHtml, navegarLinkConteudo } from '@/utils/linksPortalAntigo'

    export default {
        name: 'viewLEICO',
        props: {
            dados: Object,
            busca: Object,
        },
        computed: {
            totalReg() {
                return (this.dados.legislacaoAnotacao || []).filter(a => a.flRegulamentacao === 'Sim').length
            },
            totalNotas() {
                return (this.dados.legislacaoAnotacao || []).length - this.totalReg
            },
            totalAnotacoes() {
                return (this.dados.legislacaoAnotacao || []).length
            },
        },
        methods: {
            montaAnotacoes() {
                const $this = this
                const html = this.dados.legislacao.htmlLegislacao || ''
                const htmlFormat = normalizarLinksConteudoNoHtml(html).replace(new RegExp("{{idLegislacaoAnotacao-(.*?)-(.*?)}}", "g"), function (match, p1) {
                    if (!$this.dados.flExibeLeiComentada) return ""
                    const obj = ($this.dados.legislacaoAnotacao || []).find(x => x.idLegislacaoAnotacao == p1)
                    return obj ? htmlGatilhoAnotacao(obj, $this.dados.lstTipoAnotacao) : ""
                })

                this.$nextTick(function () {
                    $("#htmlLegislacao").html(htmlFormat)
                    $this.bindAnotacoes()
                    setTimeout(function () {
                        if ($this.busca && $this.busca.urlArquivo) {
                            const gatilho = document.querySelector('.ver_anotacao[data-id="' + $this.busca.urlArquivo + '"]')
                            if (gatilho && !gatilho.classList.contains('active')) gatilho.click()
                            const el = document.getElementById('LegislacaoAnotacao-' + $this.busca.urlArquivo)
                            if (el) el.scrollIntoView()
                        }
                    }, 1000)
                })
            },

            bindAnotacoes() {
                const $this = this
                $('#htmlLegislacao').off('click.lei keydown.lei').on('click.lei keydown.lei', '.ver_anotacao', function (e) {
                    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return
                    e.preventDefault()

                    const id = $(this).data('id')
                    const painel = $('#LegislacaoAnotacao-' + id)
                    if (!painel.html()) {
                        const obj = ($this.dados.legislacaoAnotacao || []).find(x => x.idLegislacaoAnotacao == id)
                        if (obj) painel.html(htmlPainelAnotacao(obj, $this.dados.lstTipoAnotacao))
                    }

                    $(this).toggleClass('active')
                    painel.toggleClass('active')
                })
            },

            handleClick(e) {
                if (navegarLinkConteudo(e, this.$router)) return
                const alvo = e.target.closest('#downloadAnotacao, .anotacao-arquivo')
                if (!alvo) return
                const value = alvo.getAttribute('data-url')
                if (!value) return
                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${value}`,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', value.split('/').pop())
                    document.body.appendChild(link)
                    link.click()
                })
            },

            imprimir() {
                this.$el.querySelectorAll('.ver_anotacao').forEach(a => {
                    if (!a.classList.contains('active')) a.click()
                })
                $("#conteudoImprimir").html($("#divImprimir").html())
                /*eslint-disable */
                $("#conteudoImprimir .ver_anotacao").unbind("click")
                $("#conteudoImprimir .legislacao_anotacao").show()
                $("#conteudoImprimir .ver_anotacao").hide()
                $("#conteudoImprimir .anotacao_oculta_imprimir").hide()
                $("#conteudoImprimir .txt-link").show()
                const html = document.getElementById('conteudoImprimir').innerHTML + cssImpressaoLei()
                const tela_impressao = window.open('about:blank')
                tela_impressao.document.write(html)
                tela_impressao.window.print()
                tela_impressao.window.close()
                $("#conteudoImprimir").html("")
                /*eslint-enable */
            },
        },
        created() {
            this.montaAnotacoes()
        },
        watch: {
            dados: {
                handler() {
                    this.montaAnotacoes()
                },
                deep: true
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/lei-comentada/view-legislacao";
    .viewLEICO { @include lei-comentada-view; }
</style>
